import { createSlice } from '@reduxjs/toolkit';
import { MeetingConfig } from 'shared/types/common.interface';
import { generateVideoToken } from 'utils/util';

export interface ZoomState {
  meetingArgs: MeetingConfig;
}

const initialState: ZoomState = {
  meetingArgs: {
    sdkKey: process.env.REACT_APP_SDK_KEY,
    sdkSecret: process.env.REACT_APP_SDK_SECRET,
    webEndpoint: 'zoom.us',
    topic: '',
    name: '',
    password: '',
    signature: '',
    sessionKey: '',
    userIdentity: '',
    role: 1,
    cloud_recording_option: '0',
    cloud_recording_election: '',
  },
};

const zoomSlice = createSlice({
  name: 'zoom',
  initialState,
  reducers: {
    setMeetingArgs: (state, action) => {
      state.meetingArgs = action.payload;
    },
    setTopic: (state, action) => {
      state.meetingArgs.topic = action.payload;
    },
    setUserInfo: (state, action) => {
      state.meetingArgs.name = action.payload;
    },
    getDebateInfoFromCard: (state, action) => {
      state.meetingArgs.topic = action.payload.topic;
      state.meetingArgs.name = action.payload.name;
      state.meetingArgs.userIdentity = action.payload.userIdentity;
      state.meetingArgs.signature = generateVideoToken(
        state.meetingArgs.sdkKey,
        state.meetingArgs.sdkSecret,
        state.meetingArgs.topic,
        state.meetingArgs.password,
        state.meetingArgs.sessionKey,
        state.meetingArgs.userIdentity,
        state.meetingArgs.role,
        state.meetingArgs.cloud_recording_option,
        state.meetingArgs.cloud_recording_election,
      );
    },
  },
});

export const { setMeetingArgs, setTopic, setUserInfo, getDebateInfoFromCard } = zoomSlice.actions;

export const zoomReducer = zoomSlice.reducer;
